import context from '../../../config/context'

export const csrfRequest = ({ headers, ...params }) =>
  request({
    ...params,
    headers: { ...headers, 'X-CSRF-TOKEN': context.csrfToken }
  })

export const request = ({ url, method = 'POST', headers = {}, data: body }) =>
  fetch(url, {
    method,
    headers: { ...headers, Accept: 'application/json' },
    cache: 'no-cache',
    credentials: 'include',
    body
  }).then(response => {
    if (response.status === 401) {
      return response.json().then(json => {
        throw { redirect_uri: json.redirect_uri }
      })
    }

    return Promise.resolve(response)
  })
